import { gql } from "@apollo/client";

export const GET_PURCHASER_BRANDS = gql`
  query PurchaserBrands($purchaserId: Int!) {
    purchaserBrands(purchaserId: $purchaserId) {
      brandId
      brandName
      brandKey
      brandPurchaserId
      purchaserInboxEmailId
      isActive
    }
  }
`;
